export const availableIssueManagerContextsQueryKeys = {
  all: ['available-issue-manager-contexts'] as const,
};
